import FeatureUnifiedResourceInstance from "../../../../resources/expapiunified/Feature.unified.resource.js";
import { createUnifiedRestApi } from "../utils.js";
const builder = createUnifiedRestApi(
  FeatureUnifiedResourceInstance,
  "features",
  (state) => state.features
);
const {
  actions: getFeatureOperationChecksActions,
  selectAsyncRequest: selectGetFeatureOperationChecksAsyncRequest,
  isOfType: isGetFeatureOperationChecks
} = builder.addGetAction(
  "OPERATION_CHECKS",
  (inputPayload) => FeatureUnifiedResourceInstance.getOperationChecksAsync(inputPayload.workspaceId, inputPayload.id)
);
const getFeatureOperationChecksAsync = getFeatureOperationChecksActions.load;
const resetGetFeatureOperationChecksAsync = getFeatureOperationChecksActions.reset;
const {
  actions: archiveFeatureActions,
  isOfType: isArchiveFeature,
  selectAsyncRequest: selectArchiveFeatureAsyncRequest
} = builder.addCreateOrUpdateAction(
  "ARCHIVE",
  (inputPayload) => FeatureUnifiedResourceInstance.archiveFeatureAsync(inputPayload.workspaceId, inputPayload.id)
);
const archiveFeatureAsync = archiveFeatureActions.load;
const resetArchiveFeatureAsync = archiveFeatureActions.reset;
const {
  epic: featuresEpic,
  reducer: featuresReducer,
  actions: featuresActions,
  matchers: featuresMatchers,
  selectors,
  getDefaultReducerState: getDefaultFeaturesReducerState
} = builder.create();
const {
  selectAll: selectAllFeatures,
  selectById: selectFeatureById,
  selectGetAsyncRequest: selectGetFeatureAsyncRequest,
  selectCreateOrUpdateAsyncRequest: selectCreateOrUpdateFeatureAsyncRequest,
  selectDeleteAsyncRequest: selectDeleteFeatureAsyncRequest,
  selectQueryAsyncRequest: selectQueryFeaturesAsyncRequest
} = selectors;
const {
  getAsync: getFeatureAsync,
  queryAsync: queryFeaturesAsync,
  createOrUpdateAsync: createOrUpdateFeatureAsync,
  deleteAsync: deleteFeatureAsync,
  resetCreateOrUpdateAsync: resetCreateOrUpdateFeatureAsync,
  resetDeleteAsync: resetDeleteFeatureAsync
} = featuresActions;
export {
  archiveFeatureAsync,
  createOrUpdateFeatureAsync,
  deleteFeatureAsync,
  featuresEpic,
  featuresMatchers,
  featuresReducer,
  getDefaultFeaturesReducerState,
  getFeatureAsync,
  getFeatureOperationChecksAsync,
  isArchiveFeature,
  isGetFeatureOperationChecks,
  queryFeaturesAsync,
  resetArchiveFeatureAsync,
  resetCreateOrUpdateFeatureAsync,
  resetDeleteFeatureAsync,
  resetGetFeatureOperationChecksAsync,
  selectAllFeatures,
  selectArchiveFeatureAsyncRequest,
  selectCreateOrUpdateFeatureAsyncRequest,
  selectDeleteFeatureAsyncRequest,
  selectFeatureById,
  selectGetFeatureAsyncRequest,
  selectGetFeatureOperationChecksAsyncRequest,
  selectQueryFeaturesAsyncRequest
};
//# sourceMappingURL=features.js.map
